import { render } from "./BrowserInfoDetector.vue?vue&type=template&id=14123010&scoped=true"
import script from "./BrowserInfoDetector.vue?vue&type=script&lang=js"
export * from "./BrowserInfoDetector.vue?vue&type=script&lang=js"

import "./BrowserInfoDetector.vue?vue&type=style&index=0&id=14123010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14123010"]])

export default __exports__